import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function campanhaPerfilPadraoValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const destinoId = control.get('destinoId')?.value;
    if (typeof destinoId !== 'string' || !destinoId.trim()) {
      return null;
    }

    const idPerfilPadrao = control.get('idPerfilInvestimentoDef')?.value;
    if (idPerfilPadrao) {
      return null;
    }

    return { perfilPadraoRequired: true };
  };
}
